import { render, staticRenderFns } from "./ConsultationCreate.vue?vue&type=template&id=4f08fd9b&scoped=true"
import script from "./ConsultationCreate.vue?vue&type=script&lang=js"
export * from "./ConsultationCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f08fd9b",
  null
  
)

export default component.exports